
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IFileGpsData } from '@/types/resource.types';

@Component({
    name: 'BetaChip',
})
export default class BetaChip extends Vue {
    @Prop({type: Object, required: true})
    readonly gps: IFileGpsData;

    /* Data
    ============================================*/

    get altitude(): string {
        if(!this.gps) return '';
        if(!this.gps.altitude) return '';
        return this.gps.altitude + "m"
    }
    get latitude(): string {
        if(!this.gps) return '';
        if(!this.gps.latitude) return '';
        let direction = 'N' 
        if(this.gps.latitude < 0){
            direction = 'S';
        }
        return Math.abs(this.gps.latitude) + direction
    }
    get longitude(): string {
        if(!this.gps) return '';
        if(!this.gps.longitude) return '';
        let direction = 'E' 
        if(this.gps.longitude < 0){
            direction = 'W';
        }
        return Math.abs(this.gps.longitude) + direction
    }

}

